import tools from './tools';

// SelectWithCustomInput component
export default function (options = {}) {
    let root,
        select,
        input,
        hidden,
        attribute,
        isSelect = true,
        skipWatcher = false;

    const component = {
        internalValue: '',
        select: '',
        input: '',

        get value() {
            return this.internalValue;
        },

        set value(value) {
            this.internalValue = value;
        },

        init() {
            root = this.$root;
            select = root.querySelector('[x-ref="select"]');
            isSelect = select !== null;
            input = this.$refs.input;
            hidden = this.$refs.hidden;
            attribute = tools.getName(root);
            this.internalValue = hidden.value;

            const valueSelector = (value) => `${isSelect ? 'option' : 'input[type="radio"]'}[value="${value}"]`;

            if (root.querySelector(valueSelector(this.internalValue))) {
                this.showInput = false;
                this.select = this.internalValue;
            } else {
                this.showInput = true;
                this.select = this.customValue;
                this.input = this.internalValue;
            }

            let labelElement = document.querySelector(`label[for="${tools.getName(root)}"]`);

            if (labelElement) {
                labelElement.addEventListener('click', () => {
                    if (this.showInput) {
                        input.focus();
                    } else {
                        if (isSelect) {
                            select.focus();
                        }
                    }
                });
            }

            this.$watch('internalValue', (value) => {
                if (skipWatcher) return;

                if (value === '' || root.querySelector(valueSelector(value))) {
                    this.showInput = false;
                    this.select = value;
                    this.input = '';
                    hidden.value = value;
                } else {
                    this.showInput = true;
                    this.select = this.customValue;
                    this.input = value;
                    hidden.value = value;
                }
            });
        },

        selectChange(event) {
            let value = event.target.value;
            skipWatcher = true;

            if (value === this.customValue) {
                this.showInput = true;
                value = '';
            } else {
                this.showInput = false;
            }

            if (this.showInput) {
                if (hidden._x_model) {
                    hidden._x_model.set(this.input);
                } else {
                    this.internalValue = this.input;
                    hidden.value = this.input;
                }

                this.$nextTick(() => {
                    input.focus();

                    this.$nextTick(() => Helper.dispatchCustomEvent('revalidate', { attribute }), 1500);
                });
            } else {
                if (hidden._x_model) {
                    hidden._x_model.set(value);
                } else {
                    this.internalValue = value;
                    hidden.value = value;
                }

                this.$nextTick(() => Helper.dispatchCustomEvent('revalidate', { attribute }));
            }

            this.$nextTick(() => {
                skipWatcher = false;
                input.focus();
            });
        },

        inputChange(event) {
            let value = event.target.value;

            if (this.showInput) {
                skipWatcher = true;

                if (hidden._x_model) {
                    hidden._x_model.set(value);
                } else {
                    this.internalValue = value;
                    hidden.value = value;
                }

                this.$nextTick(() => {
                    skipWatcher = false;
                    Helper.dispatchCustomEvent('revalidate', { attribute });
                });
            }
        },

        focus() {
            (this.showInput ? input : select).focus();
        },
    };

    return Object.assign(component, options);
}
